/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaIconCancelFilled from 'DesignSystem/Svgs/TysiaIconCancelFilled/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Topbar/Tabs/QuickAccess/Tab/CloseAction/Content",
  onMouseEnter,
  onMouseLeave,
  hovered,
  selected
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  onMouseEnter,
  onMouseLeave,
  hovered,
  selected
  
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<button
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 className={`views-block ${styles.Vertical}`}
>
<TysiaIconCancelFilled
  viewPath={`${viewPath}/TysiaIconCancelFilled`}
 width={16}
 height={16}
 fill={hovered && selected ? dtColorsNeutral300 : hovered ? dtColorsNeutral300 : selected ? dtColorsNeutral500 : dtColorsNeutral500}
/>
</button>
{children}
</React.Fragment>)
}